export default function extractGaClientId() {
  if (window && window.ga && window.ga.getAll) {
    const UATracker = ga.getAll().find(it => !!it.get('clientId'));

    if (UATracker) {
      return UATracker.get('clientId');
    }
  }

  return '';
}



// WEBPACK FOOTER //
// ./utils/extractGaClientId.js